import type { ApiClientInfo } from '@tadpoles/api-client'

export const FamilyApplicationId = 'com.teachingstrategies.family'
export const FamilyApplicationName = 'SmartTeach for Families'

export function createFamilyApiClientInfo(): ApiClientInfo {
    return {
        appId: FamilyApplicationId,
        appName: FamilyApplicationName,
        appVersion: __APP_VERSION__
    }
}
